// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "传热学",
      "tec": "李振南",
      "week": "1-2,4-10,14-16周",
      "add": "教学楼B座325能动"
    },
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "黄颖娜",
      "week": "1-8周",
      "add": "教学楼C座213教务"
    },
    {
      "sub": "劳动与创造",
      "tec": "付林也",
      "week": "3周",
      "add": "教学楼B座219能动"
    },
    [
      {
        "sub": "劳动与创造",
        "tec": "付林也",
        "week": "3周",
        "add": "教学楼B座219能动"
      },
      {
        "sub": "热工检测技术",
        "tec": "孙卓伦",
        "week": "4-7周",
        "add": "教学楼B座219能动"
      }
    ],
    {
      "sub": "燃烧理论及设备",
      "tec": "许琳",
      "week": "1,5-7,14-17周",
      "add": "教学楼B座219能动"
    }
  ],
  "2": [
    {
      "sub": "创造性思维与创新方法",
      "tec": "付林也",
      "week": "1-2,4-9,14-17周",
      "add": "教学楼B座221自控"
    },
    {
      "sub": "电机与拖动",
      "tec": "王东瑞",
      "week": "1-2,4-9周",
      "add": "教学楼C座115教务"
    },
    0,
    {
      "sub": "国家安全教育",
      "tec": "黄颖娜",
      "week": "1,4-5,7周",
      "add": "教学楼C座115教务"
    },
    {
      "sub": "就业创业指导",
      "tec": "秦玲",
      "week": "6-10周",
      "add": "教学楼C座110教务"
    }
  ],
  "3": [
    [
      {
        "sub": "泵与风机",
        "tec": "刘维岐",
        "week": "1-2,4-9周",
        "add": "教学楼C座111教务"
      },
      {
        "sub": "劳动与创造",
        "tec": "付林也",
        "week": "3周",
        "add": "教学楼B座219能动"
      }
    ],
    [
      {
        "sub": "机械设计基础",
        "tec": "李祥松",
        "week": "1-2,4-10,14-16周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "劳动与创造",
        "tec": "付林也",
        "week": "3周",
        "add": "教学楼B座219能动"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "传热学",
      "tec": "李振南",
      "week": "1-2,4-10,14-16周",
      "add": "教学楼B座325能动"
    },
    {
      "sub": "电机与拖动",
      "tec": "王东瑞",
      "week": "1-2,4-9周",
      "add": "教学楼C座114教务"
    },
    [
      {
        "sub": "工程伦理",
        "tec": "王若曦毛云秀",
        "week": "1-2,4-9周",
        "add": "教学楼B座325能动"
      },
      {
        "sub": "创造性思维与创新方法",
        "tec": "付林也",
        "week": "14-17周",
        "add": "教学楼B座218自控"
      }
    ],
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "黄颖娜",
      "week": "1-8周",
      "add": "教学楼C座213教务"
    },
    {
      "sub": "热工检测技术",
      "tec": "孙卓伦",
      "week": "4-7周",
      "add": "教学楼B座219能动"
    }
  ],
  "5": [
    {
      "sub": "泵与风机",
      "tec": "刘维岐",
      "week": "1-2,4-9周",
      "add": "教学楼C座311教务"
    },
    {
      "sub": "机械设计基础",
      "tec": "李祥松",
      "week": "1-2,4-10,14-16周",
      "add": "教学楼C座214教务"
    },
    {
      "sub": "国家安全教育",
      "tec": "黄颖娜",
      "week": "1,4-5,7周",
      "add": "教学楼C座213教务"
    },
    {
      "sub": "燃烧理论及设备",
      "tec": "许琳",
      "week": "1,5-7,14-17周",
      "add": "教学楼B座219能动"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
